import type { NodeViewProps } from '@tiptap/react';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { FormattedMessage } from 'react-intl';

export function EditableDocumentTitle({ node }: NodeViewProps) {
  return (
    <NodeViewWrapper as="h1">
      {!node.textContent.trim().length && (
        <span className="pointer-events-none float-left h-0 text-gray-300">
          <FormattedMessage id="component:placeholder.article-title" defaultMessage="Title" />
        </span>
      )}
      <NodeViewContent />
    </NodeViewWrapper>
  );
}
